import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './mutation.action';
import { Mutation } from './mutation.model';

export interface MutationRecordsState {
    listData: Mutation[];
    singleData: Mutation;
    loading: boolean;
    error: any;
    total: number;
    mutationData: {countryList: any[], clubs: any[]}
}

export const initialState: MutationRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    mutationData: {countryList:[], clubs:[]}
};


export const MutationRecordReducer = createReducer(

    initialState,
    
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);